import React from 'react';

const Button = ({
    children,
    onClick,
    type = 'button',
    variant = 'primary',
    size = 'md',
    isLoading = false,
    disabled = false,
    fullWidth = false,
    icon = null,
    className = '',
    style = {},
    ...props
}) => {
    // Base styles
    const baseStyle = {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        fontWeight: '600',
        borderRadius: '8px',
        transition: 'all 0.2s ease-in-out',
        cursor: disabled || isLoading ? 'not-allowed' : 'pointer',
        opacity: disabled || isLoading ? 0.7 : 1,
        border: 'none',
        outline: 'none',
        width: fullWidth ? '100%' : 'auto',
    };

    // Size variants
    const sizeStyles = {
        sm: { padding: '6px 14px', fontSize: '13px' },
        md: { padding: '10px 20px', fontSize: '15px' },
        lg: { padding: '14px 28px', fontSize: '17px' },
    };

    // Color variants
    const variantStyles = {
        primary: {
            background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)',
            color: '#ffffff',
            boxShadow: '0 4px 14px 0 rgba(79, 70, 229, 0.39)',
        },
        secondary: {
            backgroundColor: '#374151',
            color: '#f9fafb',
        },
        danger: {
            background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
            color: '#ffffff',
            boxShadow: '0 4px 14px 0 rgba(220, 38, 38, 0.39)',
        },
        outline: {
            backgroundColor: 'transparent',
            color: '#6366f1',
            border: '1.5px solid #6366f1',
        },
        success: {
            background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
            color: '#ffffff',
            boxShadow: '0 4px 14px 0 rgba(16, 185, 129, 0.39)',
        }
    };

    const combinedStyle = {
        ...baseStyle,
        ...sizeStyles[size],
        ...variantStyles[variant],
        ...style,
    };

    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled || isLoading}
            style={combinedStyle}
            className={`btn-common ${className}`}
            {...props}
        >
            {isLoading ? (
                <>
                    <svg
                        style={{
                            animation: 'spin 1s linear infinite',
                            height: '16px',
                            width: '16px',
                            marginRight: '6px',
                        }}
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <circle
                            style={{ opacity: 0.25 }}
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                        ></circle>
                        <path
                            style={{ opacity: 0.75 }}
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                    </svg>
                    <span>Loading...</span>
                </>
            ) : (
                <>
                    {icon && <span className="btn-icon">{icon}</span>}
                    {children}
                </>
            )}
        </button>
    );
};

export default Button;
